const TIME_LIVING_PROPERTY = [
    { value: "UpTo11Months", label: "Até 11 meses" },
    { value: "From1To10Years", label: "De 1 a 10 anos" },
    { value: "From10To20Years", label: "De 10 a 20 anos" },
    { value: "Over20Years", label: "Mais de 20 anos" },
];

export default TIME_LIVING_PROPERTY